var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#D9DFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9544_40210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#D9DFFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9544_40210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 32.9998C26.9999 36.3145 25.5337 39.2867 23.2146 41.3035C21.2832 42.983 18.7603 43.9998 15.9999 43.9998C13.2395 43.9998 10.7165 42.983 8.78516 41.3035C6.46601 39.2867 4.99988 36.3145 4.99988 32.9998C4.99988 26.9246 9.92475 21.9998 15.9999 21.9998C22.075 21.9998 26.9999 26.9246 26.9999 32.9998Z",
    fill: "url(#paint0_linear_9544_40210)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 4.8,
    r: 4.8,
    transform: "matrix(1 0 0 -1 11.2001 18.5996)",
    fill: "url(#paint1_linear_9544_40210)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9544_40210",
    x1: -1.19243,
    y1: 21.9998,
    x2: 31.7078,
    y2: 25.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9544_40210",
    x1: -2.7021,
    y1: 5.38355e-7,
    x2: 11.6544,
    y2: 1.36427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678AF5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.2eebacb31a4cf2ce78b7034fbfaf2b67.svg";
export { ForwardRef as ReactComponent };